import { Doughnut } from "./BaseCharts";

export default {
  extends: Doughnut,
  props: {
    labels: {
      type: Array,
      default() {
        return [];
      }
    },
    bgColor: {
      type: Array,
      default() {
        return [];
      }
    },
    numData: {
      type: Array,
      default() {
        return [];
      }
    },
    tooltipsOpen:{
      type:Boolean,
      default:false
    },
    timeout:{
      type:Number,
      default:1
    },
    unitLabel:{
      type:String,
      default:''
    },
  },
  mounted() {
    var unitLabel = this.unitLabel
    setTimeout(() => {
      this.renderChart(
      {
        labels: this.labels,
        datasets: [{ backgroundColor: this.bgColor, data: this.numData }]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        elements: { arc: { borderWidth: 0 } },
        cutoutPercentage: 85,
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.labels[tooltipItem.datasetIndex] || "";
              var num = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              var numComma = 0
                if (num > -1) {
                  var numComma = num
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                }
              label = data.labels[tooltipItem.index] + ": " + numComma +' '+ unitLabel;
              return label;
            }
          },
          enabled:this.tooltipsOpen
        }
      }
    );
    }, this.timeout*1000);
    
  }
};
